import { render, staticRenderFns } from "./admin_package_add.vue?vue&type=template&id=182b18b1&scoped=true&"
import script from "./admin_package_add.vue?vue&type=script&lang=ts&"
export * from "./admin_package_add.vue?vue&type=script&lang=ts&"
import style0 from "./admin_package_add.vue?vue&type=style&index=0&id=182b18b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b18b1",
  null
  
)

export default component.exports